// ============================================
// RIVA THEME - CUSTOM JAVASCRIPT
// ============================================
//
// TABLE OF CONTENTS:
// 1. Mobile Navigation  → //#region Mobile Navigation
// 2. Initialization     → //#region Initialization
//
// ============================================


//#region Mobile Navigation

class RivaMobileNav {
  constructor() {
    this.hamburger = document.querySelector('.riva-header__hamburger');
    this.menu = document.getElementById('riva-mobile-menu');
    this.overlay = document.querySelector('.riva-mobile-menu__overlay');
    this.closeBtn = document.querySelector('.riva-mobile-menu__close');

    if (!this.hamburger || !this.menu) return;

    this.init();
  }

  init() {
    this.hamburger.addEventListener('click', (e) => {
      e.preventDefault();
      this.toggle();
    });

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.close());
    }

    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.close());
    }

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen()) {
        this.close();
      }
    });

    this.menu.querySelectorAll('a.riva-mobile-menu__link, a.riva-mobile-menu__sub-link').forEach((link) => {
      link.addEventListener('click', () => {
        setTimeout(() => this.close(), 100);
      });
    });

    this.menu.querySelectorAll('[data-mobile-nav-toggle]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const item = btn.closest('.riva-mobile-menu__item--has-children');
        if (!item) return;
        const subNav = item.querySelector('[data-mobile-sub-nav]');
        if (!subNav) return;
        const isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        item.classList.toggle('is-open', !isOpen);
        if (isOpen) {
          subNav.style.maxHeight = '0';
        } else {
          subNav.style.maxHeight = subNav.scrollHeight + 'px';
        }
      });
    });
  }

  toggle() {
    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.menu.classList.add('is-open');
    this.hamburger.classList.add('is-active');
    this.hamburger.setAttribute('aria-expanded', 'true');

    if (this.overlay) {
      this.overlay.classList.add('is-visible');
      this.overlay.setAttribute('aria-hidden', 'false');
    }

    document.body.style.overflow = 'hidden';

    if (this.menu.hasAttribute('tabindex')) {
      this.menu.focus();
    }
  }

  close() {
    this.menu.classList.remove('is-open');
    this.hamburger.classList.remove('is-active');
    this.hamburger.setAttribute('aria-expanded', 'false');

    if (this.overlay) {
      this.overlay.classList.remove('is-visible');
      this.overlay.setAttribute('aria-hidden', 'true');
    }

    document.body.style.overflow = '';

    this.hamburger.focus();
  }

  isOpen() {
    return this.menu.classList.contains('is-open');
  }
}

//#endregion


//#region Initialization

document.addEventListener('DOMContentLoaded', () => {
  new RivaMobileNav();
});

//#endregion
